module.exports = __webpack_public_path__ + "img/star2.5a3b650d.svg";